// Catálogos de conversão entre o valor local do formulário e o código numérico que as
// APIs de Cadastro/Protocolo esperam — documentados pelo usuário (dono desses catálogos
// na OAB/MS), não inventados. Compartilhados entre perfilPrefillService.js (PUT
// /pessoa/:id) e dadosRequerimentoService.js (POST /requerimento/:id/dados) pra não
// duplicar a mesma tabela em 2 lugares. Arquivo com zero imports de propósito: os
// config.js dos pedidos também importam essas funções de convert.

export const ESTADO_CIVIL_TEXTO_PARA_CODIGO = {
  Casado: 1, Divorciado: 2, Solteiro: 3, Viuvo: 4,
  UniaoEstavel: 5, Outros: 6, SeparadoJudicialmente: 7, NaoInformado: 8
};

export const SEXO_TEXTO_PARA_LETRA = { masculino: 'M', feminino: 'F', 'não informado': 'N', 'nao informado': 'N' };

// Opções do radio "Sexo" dos pedidos. Os values são os mesmos textos que o
// perfilPrefillService gera a partir do cadastro (M → Masculino, F → Feminino) e
// que o converterSexo devolve como M/F — e é por eles que a regra do reservista decide.
export const SEXO_OPCOES = [
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Feminino', label: 'Feminino' }
];

// Aceita "preta" como equivalente a "negra" (nomenclatura IBGE, usada em rascunhos antigos).
export const ETNIA_TEXTO_PARA_CODIGO = {
  branca: 1, negra: 2, preta: 2, parda: 3, indigena: 4, amarela: 5, naoinformado: 0
};

export const DOADOR_ORGAOS_TEXTO_PARA_CODIGO = { SIM: 1, NAO: 2 };

export const EXERCE_FUNCAO_PUBLICA_TEXTO_PARA_CODIGO = { SIM: 1, NAO: 2 };

// Funções prontas pra usar em `dadosRequerimentoConfig.campos[].convert` — cada uma
// normaliza o valor local antes de bater no catálogo, mesma normalização já usada em
// perfilPrefillService.js.
export const converterEstadoCivil = (valor) => ESTADO_CIVIL_TEXTO_PARA_CODIGO[valor];
export const converterSexo = (valor) => SEXO_TEXTO_PARA_LETRA[String(valor || '').trim().toLowerCase()];
export const converterEtnia = (valor) => ETNIA_TEXTO_PARA_CODIGO[String(valor || '').trim().toLowerCase().replace(/\s+/g, '')];
export const converterDoadorOrgaos = (valor) => DOADOR_ORGAOS_TEXTO_PARA_CODIGO[valor];
export const converterExerceFuncaoPublica = (valor) => EXERCE_FUNCAO_PUBLICA_TEXTO_PARA_CODIGO[valor];

// Catálogo de Deficiência (tabela `Deficiencia`, fornecido pelo usuário — dono do catálogo
// no banco da OAB/MS) — substitui o antigo radio binário "Possui deficiência (PCD)" em
// todo o módulo. `value` é sempre string (convenção do form engine: toda option de
// select/radio vira string no DOM). Usado tanto pelo select do formulário quanto por
// PUT /pessoa/:id (`deficiencia`, ID numérico) e POST /requerimento/:id/dados.
export const DEFICIENCIA_OPCOES = [
  { value: '1', label: 'Deficiência Visual' },
  { value: '2', label: 'Deficiência Auditiva' },
  { value: '3', label: 'Deficiência Motora' },
  { value: '4', label: 'Deficiência Mental' },
  { value: '5', label: 'Deficiência Visual Baixa Visão' },
  { value: '6', label: 'Não Possui' },
  { value: '7', label: 'Deficiência Física' },
  { value: '8', label: 'Deficiência Intelectual' },
  { value: '9', label: 'Deficiência Múltiplas' },
  { value: '10', label: 'Deficiência Ostomia' },
  { value: '11', label: 'Transtorno do Espectro Autista' },
  { value: '12', label: 'Deficiência Locomotora' }
];

export const DEFICIENCIA_NAO_POSSUI_ID = '6';

const normalizarTextoDeficiencia = (v) => String(v || '').trim().toLowerCase();

// GET /auth/profile devolve `dadosCadastrais.deficiencia` como texto (descrição do
// catálogo, ex: "Deficiência Visual"), mas o PUT espera o ID numérico — resolvido por
// nome exato contra o mesmo catálogo acima (mesmo princípio de "nunca inventar" já
// usado pros demais catálogos deste arquivo).
const DEFICIENCIA_TEXTO_PARA_ID = Object.fromEntries(
  DEFICIENCIA_OPCOES.map(({ value, label }) => [normalizarTextoDeficiencia(label), value])
);

export const converterDeficienciaTexto = (texto) => DEFICIENCIA_TEXTO_PARA_ID[normalizarTextoDeficiencia(texto)];
